var styleDataHash = "c48e3582";
const injectCss = () => {
  var css = `.Ibwj7,.gExtk{cursor:pointer;height:14px;margin:0;padding:0;pointer-events:auto;position:relative;width:100%}.Ibwj7:hover .YZJJg,.gExtk:hover .YZJJg{opacity:1}.Ibwj7{cursor:none;pointer-events:none}.paGfg .YZJJg{opacity:1}.YZJJg{background-color:var(--ricos-action-color,#116dff);height:2px;top:50%;transform:translateY(-50%);transition:opacity .2s ease;width:100%}.YZJJg,.rfjK7{opacity:0;position:absolute}.rfjK7{background:var(--wds-tooltip-background-fill,var(--wsr-color-D10,#000624));border-radius:var(--wds-tooltip-border-radius,8px);box-shadow:var(--wds-shadow-surface-overlay-dark,var(--wsr-shadow30,0 6px 6px 0 rgba(22,45,61,.06),0 0 18px 0 rgba(22,45,61,.12)));color:var(--wds-tooltip-text-fill,var(--wsr-color-D80,#fff));font-family:var(--wds-font-family-default,var(--wsr-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,"\\30E1\\30A4\\30EA\\30AA","meiryo","\\30D2\\30E9\\30AE\\30CE\\89D2\\30B4 pro w3","hiragino kaku gothic pro",sans-serif));font-size:var(--wds-font-size-body-tiny,var(--wsr-text-font-size-tiny,12px));font-weight:var(--wds-font-weight-regular,var(--wsr-font-weight-regular,400));letter-spacing:var(--wds-font-letter-spacing-0,unset);line-height:var(--wds-font-line-height-body-tiny,var(--wsr-text-line-height-tiny,15px));padding:var(--wds-tooltip-padding-vertical-small,8px) var(--wds-tooltip-padding-horizontal-small,12px) var(--wds-tooltip-padding-vertical-small,7px);word-wrap:break-word;border:none;max-width:180px;pointer-events:none;transform:translateX(-50%) translateY(-100%) scale(.8);transition:opacity .15s ease-out,transform .15s ease-out;word-break:break-word;z-index:1000000}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var gap_spacer_styles_default = {
  "gapSpacerContainer": "gExtk",
  "gapSpacerViewer": "Ibwj7",
  "gapSpacerLine": "YZJJg",
  "gapSpacerFocused": "paGfg",
  "gapSpacerTooltip": "rfjK7"
};
export {
  gap_spacer_styles_default as default,
  injectCss
};
//# sourceMappingURL=gap-spacer-styles-scss.js.map
